<div class="flex flex-col px-6 pt-6 items-center gap-2">
  <h1 class="headline-small text-primary text-center">{{ 'Details and style' | translate }}</h1>
</div>

<app-dialog-content>
  <form [formGroup]="styleForm" class="flex flex-col gap-6" data-testid="details-and-style">
    <p class="body-medium text-on-surface-variant m-0">
      {{ 'Update style and level of detail of this document' | translate }}
    </p>

    <div
      class="flex items-center gap-2 w-full px-3 py-2 rounded-[4px] bg-tertiary-99 border border-tertiary-50"
      data-testid="details-and-style-warning">
      <mat-icon svgIcon="warning-triangle" class="!text-tertiary-30 shrink-0"></mat-icon>
      <p class="label-large !text-tertiary-30 m-0">
        {{ 'Updating these settings will regenerate this document, all the manual changes will be deleted' | translate }}
      </p>
    </div>

    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-8 pb-6 border-b border-surface-container">
        <app-option-slider
          variant="stops"
          [title]="'Detail level'"
          [options]="detailLevelOptions"
          [value]="styleForm.value.detailLevel"
          (valueChange)="onSliderChange('detailLevel', $event)">
        </app-option-slider>

        <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
          <mat-label>{{ 'Format mode' | translate }}</mat-label>
          <mat-select formControlName="formatMode" data-testid="format-mode-select">
            <mat-option *ngFor="let option of formatModeOptions" [value]="option.value">
              {{ option.label | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="pb-6 border-b border-surface-container">
        <div class="bg-on-primary border border-surface-varient rounded-lg p-4 flex flex-col gap-2 md:flex-row md:items-center md:justify-between md:min-h-20" data-testid="abbreviation-policy">
          <div class="title-medium text-on-surface">{{ 'Abbreviations' | translate }}</div>
          <mat-radio-group formControlName="abbreviationPolicy" class="flex items-center gap-6" data-testid="abbreviation-policy-group">
            <mat-radio-button value="minimal">{{ 'Off' | translate }}</mat-radio-button>
            <mat-radio-button value="balanced">{{ 'On' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="flex flex-col">
        <app-option-slider
          variant="stops"
          [title]="'Quotations'"
          [options]="quotationOptions"
          [value]="styleForm.value.quotationPolicy"
          (valueChange)="onSliderChange('quotationPolicy', $event)">
        </app-option-slider>
      </div>
    </div>
  </form>
</app-dialog-content>

<app-dialog-footer>
  <div class="flex items-center gap-6 w-full mt-6">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="cancel()"
      class="flex-1 [--mdc-outlined-button-container-height:48px]"
      data-testid="details-and-style-cancel">
      {{ 'Cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="apply()"
      class="flex-1 [--mdc-filled-button-container-height:48px]"
      data-testid="apply-new-settings">
      {{ 'Apply new settings' | translate }}
    </button>
  </div>
</app-dialog-footer>
